import React, { useEffect, useState } from 'react'
import { Row, Table } from 'react-bootstrap'

import { getFilesDetailsDocsAPI } from '../../../../services/files'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import CheckUserAdmin from '../../../../helper/check-user-admin'
import FileDocsTable from '../file-docs-table'
import moment from 'moment'

function Document() {
  // let [searchParams, setSearchParams] = useSearchParams()
  // const orgId = searchParams.get('orgId')
  // const code = searchParams.get('code')

  const { profile } = useSelector((state) => state.profileReducer)

  const orgId = profile?.orgId
  const code = profile?.code
  const [docsType, setDocsType] = useState([])

  useEffect(() => {
    if (orgId && code) getFilesDetailsDocs()
  }, [orgId, code])
  const getFilesDetailsDocs = async () => {
    const result = await getFilesDetailsDocsAPI({ orgId, code })
    if (!result) return

    const newData = result.result.map((d, i) => {
      return {
        value: d.id,
        label: d.document,
        isFile: d.isFile,
        insertDate: d.insert_date,
        mandatory: d.mandatory
      }
    })

    setDocsType(newData)
  }
  const roleId = useSelector((state) => state.roleReducer.role)
  const profileId = useSelector((state) => state.loginReducer.profile)
  const roles = CheckUserAdmin(profileId.roles, roleId)
  return (
    <Row>
      <p className="text-primary">Document</p>
      <Table>
        <thead
          className="bg-hrms text-white "
          style={{ position: 'sticky', top: '0px' }}
        >
          <tr className="font-title-table ">
            <th
              style={{ whiteSpace: 'nowrap' }}
              className="fw-normal text-center"
            >
              #
            </th>
            <th style={{ whiteSpace: 'nowrap' }} className="fw-normal">
              Document
            </th>
            <th
              style={{ whiteSpace: 'nowrap' }}
              className="fw-normal text-center"
            >
              Upload Date
            </th>
            {/* <th
              style={{ whiteSpace: 'nowrap' }}
              className="fw-normal text-center"
            >
              View
            </th> */}
            <th style={{ whiteSpace: 'nowrap' }} className="text-center">
              <span className="fw-normal ">File </span>
              <span className="fw-light small ">(PDF Max 8 MB)</span>
            </th>
          </tr>
        </thead>

        <tbody>
          {' '}
          {docsType &&
            docsType.map((d, i) => (
              <>
                <FileDocsTable
                  keys={i}
                  typeId={d.value}
                  detail={d.label}
                  isFile={d.isFile}
                  insertDate={
                    d.insertDate
                      ? moment(d?.insertDate).format('DD/MM/YYYY')
                      : '-'
                  }
                  idcode={{ orgId, code }}
                  fnData={getFilesDetailsDocs}
                  roles={roles}
                  data={d}
                  mandatory={d.mandatory}
                  orgId={orgId}
                  code={code}
                />
              </>
            ))}
        </tbody>
      </Table>

      <>
        {/* <FileDocs
            key={i}
            detail={d.label}
            isFile={d.isFile}
            idcode={{ orgId, code }}
            fnData={getFilesDetailsDocs}
            roles={roles}
          /> */}
      </>
    </Row>
  )
}

export default Document
